module.exports = __webpack_public_path__ + "img/lebo_logo.ba822979.png";